import { Layers } from "appworks/graphics/layers/layers";
import { BetMenuControl } from "appworks/ui/controls/standard/menu/bet-menu-control";
import { ControlFactory } from "../control-factory";

export class BetMenuControlFactory implements ControlFactory {
    /**
     * Checks for buttons unique to the betsettings scene in the MenusContent layer.
     *
     * @param {Layers} layer - The layer to filter.
     * @returns {boolean} - True if the layer has the necessary buttons, false otherwise.
     */
    public filter(layer: Layers) {
        return layer.getFlexiButton("stake_select") != null;
    }

    /**
     * Builds a bet menu control based on the given layer.
     *
     * @param {Layers} layer - Active layer.
     * @returns {BetMenuControl[]} - An array of BetMenuControl objects built from the given layer.
     */
    public build(layer: Layers) {
        return [
            new BetMenuControl(
                layer,
                layer.getButton("stake_select")
                )
        ];
    }
}